import { useQuery } from '@tanstack/react-query';
import { api } from './api';

/**
 * The signed-in account, from the cache the shell already fills.
 *
 * Same query key, so a list asking for it costs nothing: React Query hands back
 * what the shell fetched rather than going again.
 */
export function useIsPlatformAdmin(): boolean {
  const session = useQuery({ queryKey: ['me'], queryFn: api.me });
  return session.data?.role === 'super_admin';
}
